module.exports = __webpack_public_path__ + "static/quality-0cf90e04f94baeec1eb9d088beec8cbe.jpg";